import Component from '@ember/component';
import { service } from '@ember/service';
import type CurrentUser from 'donor-elf-web/services/current-user';
import { LinkTo } from '@ember/routing';

export default class TopNavbarCoachingComponent extends Component {
  @service declare currentUser: CurrentUser;
  classNames = ['flex-grow-1', 'd-flex'];

  <template>
    <div class='nav-item'>
      <span class='navbar-coach-reports-title'>
        Coach Reports
      </span>
    </div>
    {{#if this.currentUser.hasMultipleCoachingIndividuals}}
      <div class='nav-item ml-auto'>
        <LinkTo @route='coaching.individuals.index' class='nav-link pl-0'>
          All Coaching Individuals
        </LinkTo>
      </div>
    {{/if}}
  </template>
}
